<rt-box variant="padding-small" [style.height]="height ? height + 'px' : ''" layout-vertical>
  <rt-placeloader></rt-placeloader>
  <rt-placeloader *ngIf="!onlyOnePlaceloader" class="short"> </rt-placeloader>
</rt-box>
